import LinkWithArrowIcon from "@/components/LinkWithArrowIcon/LinkWithArrowIcon";
import "./Faq.css";

// -----------------------------------------------------------------------------------------

export default function Faq() {
	return (
		<section className="sponsor-section">
			<header>
				<h2>FAQ</h2>

				<LinkWithArrowIcon
					href="https://forms.gle/x3ahCfhurrezDCWR8"
					text="Suggest a new question"
					color="var(--primary-dim)"
					hoverColor="var(--primary-mid)"
				/>
			</header>

			<div className="questions-grid">
				<div>
					<h3>Is my contribution tax-deductible?</h3>
					<p>
						Lorem ipsum dolor sit amet consectetur adipiscing elit. Sit amet
						consectetur adipiscing elit quisque faucibus ex. Adipiscing elit
						quisque faucibus ex sapien vitae pellentesque.
					</p>
				</div>

				<div>
					<h3>Do you accept cryptocurrency?</h3>
					<p>
						Lorem ipsum dolor sit amet consectetur adipiscing elit. Sit amet
						consectetur adipiscing elit quisque faucibus ex. Adipiscing elit
						quisque faucibus ex sapien vitae pellentesque.
					</p>
				</div>

				<div>
					<h3>Who is behind the 'State of Brain Emulation' project?</h3>
					<p>
						Lorem ipsum dolor sit amet consectetur adipiscing elit. Sit amet
						consectetur adipiscing elit quisque faucibus ex. Adipiscing elit
						quisque faucibus ex sapien vitae pellentesque.
					</p>
				</div>
			</div>
		</section>
	);
}
